import { CellContext } from '@tanstack/react-table';

export const idFieldRender = <T>(info: CellContext<T, unknown>) =>
  info.getValue();
